<template>
  <div id="home">
    <div class="home-header">
      <div class="home-header-left">{{ date | dateFmt }} {{ date | timeFmt }}</div>

      <img class="home-header-title" src="../assets/images/jc/title.png" alt="晋城市老年人应急呼叫平台" />
      <!-- <img class="home-header-title" :src="title" alt="居家养老服务实时监管平台" /> -->

      <div class="home-header-right">
        <!-- <span class="home-header-weather">
          <span>{{ weatherText }}</span>
          <img :src="weatherImg" alt="天气" />
          <span>{{ temperature }}&deg;</span>
        </span> -->
        <span class="jc-title">晋城市人民政府12项民生实事项目（6）</span>
        <div v-if="alerm" class="alarmContainer">
          <div class="dot"></div>
          <div class="pulse"></div>
          <div class="pulse-big"></div>
        </div>
        <!-- <el-button @click="toLink" type="primary" size="small" round>跳转到平台</el-button> -->
        <el-divider direction="vertical"></el-divider>

        <img class="home-header-logout" src="../assets/images/icon_logout.png" alt="退出" @click="handleLogout" />
      </div>
    </div>

    <div class="home-wrapper">
      <JCMapView :left="!showLeft" :right="!showRight" @locate="onLocateSuccess"></JCMapView>
      <JCNumber></JCNumber>
      <img class="home-side-btn home-side-btn__left"
        :src="showLeft ? require('@ast/images/img_left_hide.png') : require('@ast/images/img_left_show.png')"
        @click="toggleLeftView" />
      <img class="home-side-btn home-side-btn__right"
        :src="showRight ? require('@ast/images/img_right_hide.png') : require('@ast/images/img_right_show.png')"
        @click="toggleRightView" />
      <div class="home-side-view home-side-view__left" :class="{ 'home-side-view__left--hidden': !showLeft }">
        <component v-for="item in leftView" :key="item.component" :is="item.component" :span="item.span"></component>
      </div>
      <div ref="rightView" class="home-side-view home-side-view__right"
        :class="{ 'home-side-view__right--hidden': !showRight }">
        <component v-for="item in rightView" :key="item.component" :is="item.component" :span="item.span"></component>
      </div>
    </div>

    <!-- <div class="home-footer">©️南京市浦口区人民政府永宁街道办事处 版权所有</div> -->
    <ElderHealth></ElderHealth>
    <ElderDetail></ElderDetail>
    <PopVideo></PopVideo>
    <mapLine></mapLine>
    <EqumentDetail></EqumentDetail>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { removeToken } from '@/utils/auth'
import { getHFeatherData, getLocationId } from '@/api/weather'

import dayjs from 'dayjs'
import MapView from '@/components/MapView'
import BuffetStatis from '@/components/BuffetStatis'
import DeviceAlarm from '@/components/DeviceAlarm'
import FireAlarm from '@/components/FireAlarm'
import ElderAge from '@/components/AllElderAge'
import ElderStatis from '@/components/ElderStatis'
import ElderAbility from '@/components/ElderAbility'
import ServiceData from '@/components/ServiceData'
import ServiceTimes from '@/components/ServiceTimes'
import ServiceStatis from '@/components/ServiceStatis'
import ServiceRecord from '@/components/ServiceRecord'
import ServiceDynamic from '@/components/ServiceDynamic'
import ServiceResource from '@/components/ServiceResource'
import AlarmInformation from '@/components/alarmInformation'
import ElderlyDataStatistics from '@/components/ElderlyDataStatistics'
import EquipmentDataStatistics from '@/components/EquipmentDataStatistics'
import TYEquipmentDataStatistics from '@/components/TYEquipmentDataStatistics'
import ElderlyData from '@/components/ElderlyData'
import OrganizationInformationDisplay from '@/components/OrganizationInformationDisplay'
import ElderDetail from "../components/ElderDetail"
import PopVideo from "../components/video"
import ServicePhoto from "../components/ServicePhoto"
import ElderHealth from "../components/ElderHealth"
import mapLine from "../components/map"
import EqumentDetail from "../components/EqumentDetail"
import JCMapView from "../components/JCMapView"
import JCElderlyData from "../components/JCElderlyData"
import JCElderAbility from "../components/JCElderAbility"
import JCInstallation from "../components/JCInstallation"
import JCSBInstallation from "../components/JCSBInstallation"
import JCAlarmInformation from "../components/JCAlarmInformation"
import JCline from "../components/JCline"
import JCNumber from "../components/JCNumber"
export default {
  name: 'Home',
  filters: {
    dateFmt(date) {
      return date.format('YYYY年MM月DD日')
    },
    timeFmt(date) {
      return date.format('HH:mm:ss')
    },
  },
  components: {
    PopVideo,
    MapView,
    BuffetStatis,
    DeviceAlarm,
    FireAlarm,
    ElderAge,
    ElderStatis,
    ElderAbility,
    ServiceData,
    ServiceTimes,
    ServiceStatis,
    ServiceRecord,
    ServiceDynamic,
    ServiceResource,
    AlarmInformation,
    ElderlyDataStatistics,
    EquipmentDataStatistics,
    TYEquipmentDataStatistics,
    ElderlyData,
    OrganizationInformationDisplay,
    ElderDetail,
    ElderHealth,
    ServicePhoto,
    mapLine,
    EqumentDetail,
    JCElderlyData,
    JCMapView,
    JCElderAbility,
    JCInstallation,
    JCSBInstallation,
    JCAlarmInformation,
    JCline,
    JCNumber,
  },
  computed: {
    ...mapGetters(['cid', 'title']),
  },
  data() {
    return {
      date: dayjs(),
      dateInterval: null,
      temperature: '35',
      weatherText: '晴',
      weatherImg: require('@ast/images/icon_weather.png'),
      showLeft: true,
      showRight: true,
      leftView: [],
      rightView: [],
      alerm: false,
    }
  },
  created() {
    this.getInitViewData(this.cid)
  },
  mounted() {
    this.dateInterval = setInterval(() => {
      this.date = dayjs()
    }, 1000)
    PubSub.subscribe('alerm', (msg, data) => {
      console.log("msg");
      this.alerm = data
    })
  },
  beforeDestroy() {
    if (this.dateInterval) {
      clearInterval(this.dateInterval)
      this.dateInterval = null
    }
  },
  methods: {
    toLink() {
      window.open(this.$configer.link, '_bank')
    },
    handleLogout() {
      removeToken()
      this.$router.push({ path: '/login' })
    },
    onLocateSuccess(city) {
      // city = city.substring(0, city.length - 1)
      const location = city.lng + "," + city.lat
      getHFeatherData(location).then((res) => {
        if (!res.data) return
        const data = res.data.now
        this.temperature = data.temp
        this.weatherText = data.text
        this.weatherImg = require('@ast/images/weather/' + data.icon + '.png')
      })
    },
    toggleLeftView() {
      this.showLeft = !this.showLeft
    },
    toggleRightView() {
      this.showRight = !this.showRight
    },
    getInitViewData(id) {
      this.leftView[0] = {
        name: "JCElderlyData",
        span: 1,
        component: "JCElderlyData",
      }
      this.leftView[1] = {
        name: "JCElderAbility",
        span: 1,
        component: "JCElderAbility",
      }
      this.leftView[2] = {
        name: "JCInstallation",
        span: 1,
        component: "JCInstallation",
      }
      this.rightView[0] = {
        name: "JCSBInstallation",
        span: 1,
        component: "JCSBInstallation",
      }
      this.rightView[1] = {
        name: "JCAlarmInformation",
        span: 1,
        component: "JCAlarmInformation",
      }
      this.rightView[2] = {
        name: "JCline",
        span: 1,
        component: "JCline",
      }
    },
    getInitViewData1(id) {
      this.$api
        .getInitData(id)
        .then((res) => {
          // console.log(res)
          if (!res) return
          res.forEach((item) => {
            if (item.ModuleLocation === 'left') {
              this.leftView.push({
                name: item.ModuleName,
                span: item.ModuleZB,
                component: item.ModuleCode,
              })
            } else {
              this.rightView.push({
                name: item.ModuleName,
                span: item.ModuleZB,
                component: item.ModuleCode,
              })
            }

          })
          this.leftView[0] = {
            name: "ElderlyData",
            span: 1,
            component: "ElderlyData",
          }
          this.rightView[0] = {
            name: "ServicePhoto",
            span: 1,
            component: "ServicePhoto",
          }
          this.rightView[1] = {
            name: "OrganizationInformationDisplay",
            span: 1,
            component: "OrganizationInformationDisplay",
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss">
.jc-title{
  font-size: 24px;
  background: -webkit-linear-gradient(#b8f7ff, #3cc4fd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.alarmContainer {
  width: 50px;
  height: 50px;
  margin-left: 20px;

  .dot {
    position: absolute;
    width: 30px;
    height: 30px;
    // left: 10px;
    top: 10px;
    background: url(../assets/images/alermImg.gif) no-repeat;
    background-size: 100%;
    z-index: 200;
  }

  .pulse {
    background: rgba(239, 45, 2, 0.6) !important;
    -webkit-animation: warn 0.9s ease-out;
    -moz-animation: warn 0.9s ease-out;
    animation: warn 0.9s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    box-shadow: 1px 1px 30px #EF2D02;
  }

  .pulse,
  .pulse-big {
    position: absolute;
    width: 50px;
    height: 50px;
    border: 2px solid #EF2D02;
    background: rgba(239, 45, 2, 0.8);
    border-radius: 50%;
    z-index: 100;
    opacity: 0;
  }

  .pulse-big {
    background: rgba(239, 45, 2, 0.6) !important;
    -webkit-animation: warn1 0.9s ease-out;
    -moz-animation: warn1 0.9s ease-out;
    animation: warn1 0.9s ease-out;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    box-shadow: 1px 1px 30px #EF2D02;
  }
}

#home {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url(../assets/images/bg_home.png) no-repeat center/100% 100%;

  .home-header {
    position: relative;
    height: 6vh;
    padding-top: 1vh;
    text-align: center;
    font-size: 24px;

    &-title {
      display: inline-block;
      height: 100%;
    }

    &-left {
      position: absolute;
      top: 10px;
      left: 100px;
      bottom: 0;
      line-height: 5vh;
    }

    &-right {
      display: flex;
      align-items: center;
      position: absolute;
      top: 10px;
      right: 50px;
      bottom: 0;

      .el-divider {
        margin-left: 20px;
        margin-right: 20px;
        background-color: #2b5473;
      }

      .home-header-logout {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }

    &-weather {
      display: flex;
      align-items: center;

      img {
        width: 35px;
        height: auto;
        margin-left: 10px;
        margin-right: 10px;
      }

      span+span {
        margin-left: 10px;
      }
    }
  }

  .home-wrapper {
    position: relative;
    height: 94vh;
    padding: 20px 40px 40px;

    .home-side {
      &-btn {
        z-index: 100;
        position: absolute;
        top: 50%;
        width: 25px;
        height: 100px;
        margin-top: -50px;
        cursor: pointer;

        &__left {
          left: 15px;
        }

        &__right {
          right: 15px;
        }
      }

      &-view {
        z-index: 90;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 20px;
        bottom: 40px;
        width: 500px;
        height: 87.5vh;
        opacity: 1;
        transition: all 1s;

        &__left {
          left: 40px;

          &--hidden {
            transform: translateX(-100%);
            opacity: 0;
          }
        }

        &__right {
          right: 40px;

          &--hidden {
            transform: translateX(100%);
            opacity: 0;
          }
        }
      }
    }
  }

  .home-footer {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding-bottom: 10px;
    text-align: center;
    font-size: 15px;

    img {
      display: inline-block;
      vertical-align: bottom;
      width: 60px;
      height: auto;
    }

    span {
      display: inline-block;
      vertical-align: bottom;
      margin-left: 5px;
      font-size: 15px;
    }
  }
}
</style>
